export const qaLabelCampaigns = {
    addCampaignButton: 'campaign--add-campaign',
    // Card
    campaignCardTitle: 'campaigns--card--title',
    campaignCardTitleValue: '[data-campaign-name="${name}"]',
    editButton: 'campaigns--card--edit',
    deleteButton: 'campaigns--card--delete',
    campaignNameInput: 'campaigns--add-campaign-modal--name-input',
    // Modal add campaign
    addCampaignModalSaveButton: 'campaigns--add-campaign-modal--save-button',
    // Modal edit campaign
    editModal: {
        title: 'campaigns--edit-campaign-modal--title',
        //General tab
        nameInput: 'campaigns--edit-campaign-modal--name-input',
        //Theme tab
        enableThemeBtn: 'campaigns--edit-campaign-modal--theme-enable-button',
        //Widgets tab
        enableWidgetBtn: 'campaigns--edit-campaign-modal--widgets-enable-button',
        addWidgetBtn: 'campaigns--edit-campaign-modal--widgets-add-button',
        widgetRow: 'campaigns--edit-campaign-modal--widgets-row',
        deleteWidgetRow: 'campaigns--edit-campaign-modal--widgets-delete-row-button',
        widgetBodyTable: 'campaigns--edit-campaign-modal--widgets-body-table',
        dropdownwidget: 'campaigns--edit-campaign-modal--widgets-dropdown',
        //Text widget form
        textWidget: {
            nameInput: 'campaigns--edit-campaign-modal--text-widget--text-input'
        },
        widgedAddBtn: 'campaigns--edit-campaign-modal--widgets-add-btn',

    },
    editCampaignModalSaveButton: 'campaigns--edit-campaign--save-campaign'
};
